import { z } from "zod";

export const loginPayloadSchema = z.object({
  login_id: z.string(),
  password: z.string(),
}).strip();